<div id="appcontainer">
  <app-loading-screen></app-loading-screen>
  <app-scene></app-scene>
</div>
